import { useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { PageHeader } from "@/components/shared";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Plus } from "lucide-react";
import Salas from "@/pages/Salas";
import ReglasUsoSalas from "@/pages/ReglasUsoSalas";

const TABS_VALIDOS = ["salas", "reglas"];

export default function ConfigurarSalas() {
    const [params, setParams] = useSearchParams();
    const tabInicial = TABS_VALIDOS.includes(params.get("tab")) ? params.get("tab") : "salas";
    const [tab, setTab] = useState(tabInicial);

    const salasRef = useRef(null);
    const reglasRef = useRef(null);

    const onChange = (v) => {
        setTab(v);
        setParams({ tab: v }, { replace: true });
    };

    const onActionClick = () => {
        if (tab === "salas") salasRef.current?.openNew();
        else if (tab === "reglas") reglasRef.current?.openNew();
    };

    const actionLabel = tab === "salas" ? "Nueva sala" : "Nueva regla";
    const actionTestid = tab === "salas" ? "sala-new" : "regla-new";

    return (
        <div>
            <PageHeader
                title="Configurar salas"
                subtitle="Administrá salas y reglas de uso semanal por capacidad de oficina."
            />
            <Tabs value={tab} onValueChange={onChange}>
                <div className="flex items-center justify-between gap-2 mb-4">
                    <TabsList>
                        <TabsTrigger value="salas" data-testid="tab-salas">Salas</TabsTrigger>
                        <TabsTrigger value="reglas" data-testid="tab-reglas">Reglas de uso</TabsTrigger>
                    </TabsList>
                    <Button onClick={onActionClick} data-testid={actionTestid} className="h-9">
                        <Plus className="h-4 w-4 mr-1" /> {actionLabel}
                    </Button>
                </div>
                <TabsContent value="salas">
                    <Salas ref={salasRef} embedded />
                </TabsContent>
                <TabsContent value="reglas">
                    <ReglasUsoSalas ref={reglasRef} embedded />
                </TabsContent>
            </Tabs>
        </div>
    );
}
